module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-view has-header"
  }, [_c('sub-nav', {
    attrs: {
      "mold": "quickNav"
    }
  }), _vm._v(" "), _c('list', {
    attrs: {
      "mold": "thumbnail",
      "items": _vm.events
    }
  }), _vm._v(" "), _c('infinite-loading', {
    ref: "infiniteLoading",
    attrs: {
      "on-infinite": _vm.onInfinite
    }
  }, [_c('loading', {
    slot: "spinner"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37ef6108"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/HomeView.vue
// module id = 193
// module chunks = 0